import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import BindModal from './BindModal';

export default function extendSettingsPage() {
  extend(SettingsPage.prototype, 'accountItems', function (items) {
    const user = app.session.user;

    items.add(
      'bindAccount',
      <Button className="Button Button--primary" onclick={() => app.modal.show(BindModal)} disabled={user.cjlu_auth()}>
        {user.cjlu_auth() ? '已认证' : '绑定统一认证账号'}
      </Button>,
      150
    );

    items.remove('changeEmail');
    items.replace(
      'changePassword',
      <LinkButton className="Button" href="https://authserver.cjlu.edu.cn/personalInfo/personCenter/index.html#/accountsecurity" target="_blank">
        {app.translator.trans('core.forum.settings.change_password_button')}
      </LinkButton>
    );
  });

  extend(SettingsPage.prototype, 'settingsItems', function (items) {
    if (items.has('account') && items.get('account').children.length === 0) {
      items.remove('account');
    }
  });
}
